import { useState } from 'react'

import QuestionIcon from './icons/questionIcon'
import { useTranslator } from '../translator/hook'
import './HowToPlayButton.css'
import { Breakpoint, useBreakpoint } from '../breakpoints'
import { Tooltip } from '../tooltip'
import { useTooltip } from '../tooltipHook'
import { HowToPlayModal } from '../modals/help/howToPlayModal'

export const HowToPlayButton = () => {
  const { t } = useTranslator()
  const isWide = !useBreakpoint(Breakpoint.phase2)
  const [isOpen, setIsOpen] = useState(false)
  const { getReferenceProps, refs, tooltipProps } = useTooltip()

  return (
    <>
      <button
        className="how-to-play-icon-button"
        onClick={() => setIsOpen(true)}
        ref={refs.setReference}
        {...getReferenceProps()}
      >
        <QuestionIcon style={{ verticalAlign: 'middle' }} />
        {isWide && (
          <span style={{ marginLeft: '5px' }} className="how-to-play-text">
            {t('how_to_play_button')}
          </span>
        )}
      </button>
      <Tooltip
        {...tooltipProps}
        className="how-to-play-button-tooltip"
        disabled={isWide}
      >
        {t('how_to_play_button')}
      </Tooltip>
      <HowToPlayModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  )
}
